
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
  ITypeModel,
} from "@/api/types";
import { QuotationApprovalDetail } from "./types";

import Pagination from "@/components/Pagination/index.vue";
import { getUsersByJobPosition } from "@/api/users";
import {
  getQuotationDetail,
  removeQuotation,
  getSuppliersList,
} from "@/api/inquiry";
import {
  getPaymentInfo,
  getPiInfo,
} from "@/api/proforma";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { putPurchaseOrder, getDeductionInfo } from "@/api/credit-note";
import {
  createPayment,
  getStatus,
  getPaymentType,
  getRelationOrder,
  getRelationOrderToList,
  getRelationList,
} from "@/api/supplier-payment";
import { error } from "console";
import PurchaseOrderFee
  from "@/views-oms/financial-reconciliation-management/supplier-payment/create-payment/components/purchase-order-fee.vue";

@Component({
  name: "CreatePaymentOrder",
  components: {
    PurchaseOrderFee,
    Pagination,
    CreateFee: () => import("./components/CreateFee.vue"),
    CreatePayment: () => import("./components/CreatePayment.vue"),
    CreateClaim: () => import("./components/CreateClaimNew.vue"),
    Receipt: () => import("./components/Receipt.vue"),
  },
})
export default class extends Vue {
  // 是否显示所有产品号码
  private showFee = false;
  private showAmount = false;
  private selectedItem = {} as any;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();
  private showBtnStatus = true;

  // public paymentVoucherOtherFeeResList = [] as any[];
  // public relationPaymentVoucherResList = [] as any[];

  private conversionExchangeRate = 0;

  private FuKuanStatus = "";

  private claimList = [];

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as QuotationApprovalDetail[],
  };

  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "收汇单号",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "收汇单金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "登记金额",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "登记金额类型",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "金额说明",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: "", click: "handleEdit" },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  public customerInfo = {} as any;
  public customerInfoFields = [
    {
      label: "采购订单号",
      key: "piNumber",
    },
    {
      label: "交易公司",
      key: "company",
    },
    {
      label: "当前状态",
      key: "status",
    },
    {
      label: "销售员",
      key: "customerAbbr",
    },
    {
      label: "下单时间",
      key: "customerNation",
    },
    {
      label: "长期定金",
      key: "longTermDeposit",
    },
    {
      label: "产品总数量",
      key: "deliveryQuantity",
    },
    {
      label: "总货款",
      key: "conversionProfitAmount",
    },
    {
      label: "其他费用",
      key: "deliveryAmount",
    },
    {
      label: "结算金额",
      key: "orderPlacementTime",
    },
    {
      label: "备注",
      key: "remark",
    },
  ] as any;
  public paymentForm = {
    supplierId: null,
    supplier: null,
    type: null,
    paymentAmount: null,
    supplierPaymentRemaining: null,
    supplierCashRemaining: null,
    purchaser: null,
    purchaserId: null,
    accountant: null,
    paymentTime: null,
    relationPurchaseOrder: [],
    remark: null,
    customers: null,
    sellers: null,
    paymentVoucherOtherFees: [],
    relationPaymentVouchers: [],
    relationPackingList: [],
  } as any;
  private list = [
    {
      label: "付款单性质",
      prop: "type",
      key: "type",
      type: "select",
      placeholder: "请选择付款单性质",
      clearable: true,
      maxlength: 10,
      options: [],
      labelKey: "desc",
      valueKey: "name",
      rules: [
        {
          required: true,
          message: "请选择付款单性质",
          trigger: "change",
        },
      ],
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择供应商",
          trigger: "change",
        },
      ],
    },
    {
      label: "关联单据",
      prop: "relationType",
      prop2: "relationPurchaseOrder",
      key: "relationType",
      key2: "relationPurchaseOrder",
      type: "select_two_CD",
      placeholder: "请选择",
      placeholder2: "请选择",
      clearable: false,
      clearable2: false,
      multiple: false,
      multiple2: false,
      options: [],
      options2: [],
      labelKey: "label",
      valueKey: "value",
      labelKey2: "label",
      valueKey2: "label",
      disabled: false,
      disabled2: false,
    },
    {
      label: "付款剩余",
      prop: "supplierPaymentRemaining",
      key: "supplierPaymentRemaining",
      type: "inputNumber",
      placeholder: "付款剩余",
      disabled: true,
      clearable: true,
      maxlength: 50,
      precision: 2
    },
    {
      label: "定金剩余",
      prop: "supplierCashRemaining",
      key: "supplierCashRemaining",
      type: "inputNumber",
      placeholder: "定金剩余",
      disabled: true,
      clearable: true,
      maxlength: 50,
      precision: 2
    },
    {
      label: "采购员",
      prop: "purchaserId",
      key: "purchaserId",
      type: "select",
      options: [],
      labelKey: "name",
      valueKey: "id",
      placeholder: "采购员",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "客人简称",
      prop: "customers",
      key: "customers",
      type: "input",
      placeholder: "客人简称",
      clearable: true,
      maxlength: 50,
    },
    {
      label: "销售员",
      prop: "sellers",
      key: "sellers",
      type: "select",
      placeholder: "销售员",
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "abbreviation" },
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      type: "inputNumber",
      placeholder: "付款金额",
      clearable: true,
      maxlength: 50,
      precision: 2,
      rules: [
        {
          required: true,
          message: "请输入付款金额",
          trigger: "blur",
        },
      ],
    },
    {
      label: "付款日期",
      prop: "paymentTime",
      key: "paymentTime",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "付款单备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入付款备注",
      clearable: true,
      maxlength: 512,
    },
  ];
  private list2 = [
    {
      label: "付款单性质",
      prop: "type",
      key: "type",
      type: "select",
      placeholder: "请选择付款单性质",
      clearable: true,
      maxlength: 10,
      options: [],
      labelKey: "desc",
      valueKey: "name",
      rules: [
        {
          required: true,
          message: "请选择付款单性质",
          trigger: "change",
        },
      ],
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      labelKey: "abbreviation",
      valueKey: "id",
      rules: [
        {
          required: true,
          message: "请选择供应商",
          trigger: "change",
        },
      ],
    },
    {
      label: "关联单据",
      prop: "relationType",
      prop2: "relationPurchaseOrder",
      key: "relationType",
      key2: "relationPurchaseOrder",
      type: "select_two_CD",
      placeholder: "请选择",
      placeholder2: "请选择",
      disabled: false,
      disabled2: false,
      clearable: true,
      clearable2: true,
      multiple: false,
      multiple2: false,
      options: [],
      options2: [],
      labelKey: "label",
      valueKey: "value",
      labelKey2: "label",
      valueKey2: "label",
    },
    {
      label: "采购员",
      prop: "purchaserId",
      key: "purchaserId",
      type: "select",
      options: [],
      labelKey: "name",
      valueKey: "id",
      placeholder: "采购员",
      clearable: true,
      readonly: true,
      maxlength: 50,
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      type: "inputNumber",
      placeholder: "付款金额",
      clearable: true,
      readonly: true,
      maxlength: 50,
      precision: 2,
      rules: [
        {
          required: true,
          message: "请输入付款金额",
          trigger: "blur",
        },
      ],
    },
    {
      label: "付款日期",
      prop: "paymentTime",
      key: "paymentTime",
      type: "date",
      placeholder: "付款日期",
      clearable: true,
      maxlength: 50,
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "付款单备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入付款备注",
      clearable: true,
      maxlength: 512,
    },
  ];
  private feeTable = [];
  public feeCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "费用类型",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "编辑", code: "", click: "handleEdit" },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  private recordTable = [];
  public recordCol = [
    {
      label: "收汇单号",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "收汇单金额",
      prop: "shippingCode",
      key: "shippingCode",
      show: true,
      disabled: false,
    },
    {
      label: "未分配金额",
      prop: "inquiryReferenceNumber",
      key: "inquiryReferenceNumber",
      show: true,
      disabled: false,
    },
    {
      label: "已登记金额",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "到账日期",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "收汇单备注",
      prop: "inquiryReferenceNumberType",
      key: "inquiryReferenceNumberType",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "分配明细", code: "", click: "handleEdit" },
        { name: "金额登记", code: "", click: "handleEdit" },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;
  private id = "";
  private paymentInfo = {};
  private piInfo = {};
  private codesType = "";

  created() {
    this.id = this.$route.query.id as string;
    this.init();
    if (this.$route.query.type && this.$route.query.type === "cgdd") {
      this.getSuppliersList(this.$route.query.supplierAbbr as any);
      this.paymentForm.type = 'DEPOSIT'
      this.paymentForm.supplierId = this.$route.query.supplierId;
      this.paymentForm.supplier = this.$route.query.factoryAbbreviationName;
      this.list[1].disabled = true;
      this.list[2].options = [{ value: "采购订单", label: "采购订单" }];
      this.list[2].options2 = [
        { value: "this.$route.query.code", label: "this.$route.query.code" },
      ];
      this.list[2].disabled = true;
      this.list[2].disabled2 = true;
      this.paymentForm.relationType = "采购订单";
      this.paymentForm.relationPurchaseOrder = this.$route.query.code;
    }

    if (
      this.$route.query.hqPackingListCode &&
      this.$route.query.factoryAbbreviationName &&
      this.$route.query.factoryAbbreviationID
    ) {
      this.paymentForm.supplierId = this.$route.query.factoryAbbreviationID;
      this.paymentForm.supplier = this.$route.query.factoryAbbreviationName;
      this.paymentForm.relationType = "装箱单";
      this.paymentForm.relationPurchaseOrder =
        this.$route.query.hqPackingListCode;
    }
    if (
      this.$route.query.hqPackingListCode &&
      this.$route.query.factoryAbbreviationName &&
      this.$route.query.factoryAbbreviationID
    ) {
      this.list[1] = {
        label: "供应商",
        prop: "supplier",
        key: "supplier",
        type: "input",
        disabled: true,
      } as any;
      this.list[2] = {
        label: "关联单据",
        prop: "relationType",
        prop2: "relationPurchaseOrder",
        key: "relationType",
        key2: "relationPurchaseOrder",
        type: "select_two_CD",
        placeholder: "请选择",
        placeholder2: "请选择",
        clearable: false,
        clearable2: false,
        multiple: false,
        multiple2: false,
        options: [],
        options2: [],
        labelKey: "label",
        valueKey: "value",
        labelKey2: "label",
        valueKey2: "label",
        disabled: true,
      } as any;
      this.list2[1] = {
        label: "供应商",
        prop: "supplier",
        key: "supplier",
        type: "input",
        disabled: true,
      } as any;
      this.list2[2] = {
        label: "关联单据",
        prop: "relationType",
        prop2: "relationPurchaseOrder",
        key: "relationType",
        key2: "relationPurchaseOrder",
        type: "select_two_CD",
        placeholder: "请选择",
        placeholder2: "请选择",
        clearable: false,
        clearable2: false,
        multiple: false,
        multiple2: false,
        options: [],
        options2: [],
        labelKey: "label",
        valueKey: "value",
        labelKey2: "label",
        valueKey2: "label",
        disabled: true,
      } as any;
    }

    if (!this.$route.query.codesType) {
      this.codesType = "PAYMENT_VOUCHER";
    } else {
      this.codesType = this.$route.query.codesType as any;
    }
    // this.$route.query.hqPackingListCode
    // this.$route.query.factoryAbbreviationName
    // this.$route.query.factoryAbbreviationID

    if (this.$route.query.codesType === "HQ_PACKING_LIST") {
      // this.claimList
      this.getDeductionInfo(this.$route.query.hqPackingListId);
    }

    if (this.$route.query.showBtnStatus) {
      this.showBtnStatus = false;
    }
  }

  activated() {
    this.init();
  }

  private async getDeductionInfo(id) {
    const res: any = await getDeductionInfo(id);
    this.claimList = res;
  }

  private init() {
    // this.getPaymentInfo();
    // this.getPiInfo();
    // this.getTradingTermsTypes();
    this.getPaymentType();
    this.initPurchaserList();
    this.initSellerList();
    // this.getList();
  }

  private async initPurchaserList() {
    const data: any = await getUsersByJobPosition("purchaser");
    this.list.find(e => e.key === 'purchaserId').options = data;
    this.list2.find(e => e.key === 'purchaserId').options = data;
  }

  @Watch("changeType", { immediate: true })
  private watchType() {
    if (this.paymentForm.type && this.paymentForm.supplierId) {
      if (this.$route.query.type && this.$route.query.type === "ToList") {
        this.getRelationOrderToList();
      } else if (this.$route.query.type && this.$route.query.type === "cgdd") {
        this.getRelationOrder();
        console.log("ajsdjkaksdjaksdjajksdjajk");
      } else {
        if (this.paymentForm.type === "ACCOUNT_PAYMENT_PERIOD") {
          // this.resetOptions();
        } else {
          this.resetOptions();
        }
        this.resetRelation();
        this.getRelationList();
      }
    }
  }

  @Watch("changeCode", { immediate: true })
  private watchCode() {
    console.log("changeCode", this.changeCode);
    console.log("paymentForm", this.paymentForm);
    if (
      this.paymentForm.type &&
      this.paymentForm.supplierId &&
      this.paymentForm.relationPurchaseOrder.length
    ) {
      if (
        this.$route.query.type &&
        this.$route.query.type !== "ToList" &&
        this.$route.query.type &&
        this.$route.query.type !== "cgdd"
      ) {
        this.getRelationOrder();
      }
      if (!this.$route.query.type) {
        this.getRelationOrder();
      }
    }
    if (
      this.paymentForm.type &&
      this.paymentForm.supplierId &&
      !this.paymentForm.relationPurchaseOrder
    ) {
      this.resetRelation();
    }
  }

  get changeType() {
    const { type, supplierId } = this.paymentForm;
    return {
      type,
      supplierId,
    };
  }

  get changeCode() {
    const { type, supplierId, relationPurchaseOrder } = this.paymentForm;
    return {
      type,
      supplierId,
      relationPurchaseOrder,
    };
  }

  private formUpdate(obj) {
    if (obj.relationType) {
      this.getOptions2(obj.relationType);
    }
    if (
      obj.type &&
      obj.type === "ACCOUNT_PAYMENT_PERIOD" &&
      this.$route.query.type !== "cgdd"
    ) {
      this.paymentForm.relationType = "装箱单";
      this.list2[2].disabled = true;
      this.FuKuanStatus = "ACCOUNT_PAYMENT_PERIOD";
    }
    if (
      this.$route.query.type !== "ToList" &&
      this.$route.query.type !== "cgdd"
    ) {
      this.list[2].disabled2 = false;
      this.list2[2].disabled2 = false;
    }
  }

  private resetOptions() {
    this.list[2].options = [];
    this.list[2].options2 = [];
    this.list2[2].options = [];
    this.list2[2].options2 = [];
    this.paymentForm.relationType = "";
    this.paymentForm.relationPurchaseOrder = [];
  }

  private resetRelation() {
    this.paymentForm.supplierPaymentRemaining = null;
    this.paymentForm.supplierCashRemaining = null;
    this.paymentForm.purchaser = null;
    this.paymentForm.purchaserId = null;
    this.paymentForm.accountant = null;
    this.paymentForm.paymentAmount = null;
    this.paymentForm.customers = null;
    this.paymentForm.sellers = null;
  }

  /**
   * 选择单据为装箱单时 可多选，采购订单只能单选
   * 如果付款单性质为 预付款的，可以勾选多个采购订单
   * 装箱单 发货前付款 结算账期 其他
   * 采购订单 定金 下单前付款 现金 包装/配件 预付款 其他
   */
  private getOptions2(type) {
    if (type === "采购订单") {
      let obj = this.list[2].options.find((item) => item.value === type);
      this.list[2].options2 = obj.children;
      this.list2[2].options2 = obj.children;
      if (this.paymentForm.type === "预付款") {
        this.list[2].multiple2 = true;
      } else {
        this.list[2].multiple2 = false;
        this.list2[2].multiple2 = false;
      }
    }
    if (type === "装箱单") {
      let obj = this.list[2].options.find((item) => item.value === type);
      this.list[2].options2 = obj.children;
      this.list2[2].options2 = obj.children;
      this.list[2].multiple2 = true;
      this.list2[2].multiple2 = true;
    }
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.list[1].options = res;
    this.list2[1].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  private async getPiInfo() {
    const res: any = await getPiInfo(this.id);
    this.piInfo = res;
  }

  private async getPaymentInfo() {
    const res: any = await getPaymentInfo(this.id);
    const { otherFees, shippingMarks } = res;
    (this.$refs.otherFees as any).table.list = otherFees;
    this.paymentInfo = res;
    this.paymentForm = {
      ...res,
      markList: shippingMarks,
    };
  }

  private async getPaymentType() {
    const res: any = await getPaymentType();
    if (
      this.$route.query.hqPackingListCode &&
      this.$route.query.factoryAbbreviationName &&
      this.$route.query.factoryAbbreviationID
    ) {
      if (res.findIndex((item) => item.desc == "发货前付款") > -1) {
        this.list[0].options.push(
          res[res.findIndex((item) => item.desc == "发货前付款")]
        );
      }
      if (res.findIndex((item) => item.desc == "现金") > -1) {
        this.list[0].options.push(
          res[res.findIndex((item) => item.desc == "现金")]
        );
      }
      if (res.findIndex((item) => item.desc == "其他") > -1) {
        this.list[0].options.push(
          res[res.findIndex((item) => item.desc == "其他")]
        );
      }
    } else {
      this.list[0].options = res;
    }
    if (
      this.$route.query.hqPackingListCode &&
      this.$route.query.factoryAbbreviationName &&
      this.$route.query.factoryAbbreviationID
    ) {
      if (res.findIndex((item) => item.desc == "发货前付款") > -1) {
        this.list2[0].options.push(
          res[res.findIndex((item) => item.desc == "发货前付款")]
        );
      }
      if (res.findIndex((item) => item.desc == "现金") > -1) {
        this.list2[0].options.push(
          res[res.findIndex((item) => item.desc == "现金")]
        );
      }
      if (res.findIndex((item) => item.desc == "其他") > -1) {
        this.list2[0].options.push(
          res[res.findIndex((item) => item.desc == "其他")]
        );
      }
    } else {
      this.list2[0].options = res;
    }

    if (this.$route.query.type && this.$route.query.type === "cgdd") {
      if (this.list[0].options.findIndex((e) => e.desc === "账期付款") !== -1) {
        this.list[0].options.splice(
          this.list[0].options.findIndex((e) => e.desc === "账期付款"),
          1
        );
      }
      if (
        this.list[0].options.findIndex((e) => e.desc === "发货前付款") !== -1
      ) {
        this.list[0].options.splice(
          this.list[0].options.findIndex((e) => e.desc === "发货前付款"),
          1
        );
      }
      if (
        this.list2[0].options.findIndex((e) => e.desc === "账期付款") !== -1
      ) {
        this.list2[0].options.splice(
          this.list2[0].options.findIndex((e) => e.desc === "账期付款"),
          1
        );
      }
      if (
        this.list2[0].options.findIndex((e) => e.desc === "发货前付款") !== -1
      ) {
        this.list2[0].options.splice(
          this.list2[0].options.findIndex((e) => e.desc === "发货前付款"),
          1
        );
      }
    }
  }

  // 选择关联单据
  /**
   * 选择单据为装箱单时 可多选，采购订单只能单选
   * 如果付款单性质为 预付款的，可以勾选多个采购订单
   * 装箱单 发货前付款 结算账期 其他
   * 采购订单 定金 下单前付款 现金 包装/配件 预付款 其他
   */
  private async getRelationList() {
    const res: any = await getRelationList({
      supplierId: this.paymentForm.supplierId,
      type: this.paymentForm.type,
    });
    console.log(res, "getRelationList");
    this.list[2].options = res;
    this.list2[2].options = res;
    if (this.FuKuanStatus === "ACCOUNT_PAYMENT_PERIOD") {
      let obj = this.list[2].options.find((item) => item.value === "装箱单");
      this.list[2].options2 = obj.children;
      this.list2[2].options2 = obj.children;
      this.list[2].multiple2 = true;
      this.list2[2].multiple2 = true;
      this.list[2].disabled2 = true;
      this.list2[2].disabled2 = true;
      this.list2[2].options2.map((item) => {
        this.paymentForm.relationPurchaseOrder.push(item.label);
      });
      console.log("itemitem", this.paymentForm.relationPurchaseOrder);
      // asasasas
    }
  }

  // 选择关联单据后查询
  private async getRelationOrderToList(name = "") {
    const { supplierId, type } = this.paymentForm;
    let ids = this.paymentForm.relationPurchaseOrder;
    if (typeof ids === "string") {
      ids = [ids];
    }
    let codes: any;
    if (!ids.length) {
      return;
    }
    codes = ids;
    // if (this.paymentForm.relationType === '装箱单') {
    //   codes = ids;
    // } else if (this.paymentForm.relationType === '采购订单') {
    //   codes = ids;
    // } else {
    //   codes = ids[0];
    // }
    const data = {
      codes,
      supplierId,
      type,
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // const params = `supplierId=${supplierId}&type=${type}&${codes}`;
    // const params = `supplierId=${supplierId}&type=${type}`;1111
    const res: any = await getRelationOrderToList(data).then((res:any) => {
      let {
        supplierPaymentRemaining,
        supplierCashRemaining,
        purchaser,
        paymentAmount,
        customers,
        sellers,
        purchaserId,
        accountantId,
      } = res;
      this.paymentForm.supplierPaymentRemaining = supplierPaymentRemaining;
      this.paymentForm.supplierCashRemaining = supplierCashRemaining;
      this.paymentForm.purchaser = purchaser;
      this.paymentForm.purchaserId = purchaserId;
      this.paymentForm.accountant = accountantId;
      this.paymentForm.paymentAmount = paymentAmount;
      this.paymentForm.customers = customers.toString();
      this.paymentForm.sellers = sellers.toString();
      (this.$refs.otherFees as any).paymentVoucherOtherFeeResListGIVE(res.paymentVoucherOtherFeeResList);
      (this.$refs.createPayment as any).relationPaymentVoucherResListGIVE(res.relationPaymentVoucherResList);
      (this.$refs.purchaseOrderFee as any).relationPurchaseOrderFeeGIVE(res.purchaseOrderFeeDistributionResList);
      loading.close();
    }).catch(err => {
      console.log(err);
      loading.close();
    });
  }

  private async initSellerList() {
    const res:any = await getUsersByJobPosition('seller');
    this.list.find(e => e.key === 'sellers').options = res
  }

  // 选择关联单据后查询
  private async getRelationOrder() {
    const { supplierId, type } = this.paymentForm;
    let ids = this.paymentForm.relationPurchaseOrder;
    if (typeof ids === "string") {
      ids = [ids];
    }
    let codes: any;
    if (!ids.length) {
      return;
    }
    codes = ids;
    const data = {
      codes,
      supplierId,
      type,
    };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    // const params = `supplierId=${supplierId}&type=${type}&${codes}`;
    // const params = `supplierId=${supplierId}&type=${type}`;
    await getRelationOrder(data).then((res:any) => {
      console.log(res, "getRelationOrder");
      let {
        supplierPaymentRemaining,
        supplierCashRemaining,
        purchaser,
        paymentAmount,
        customers,
        sellers,
        purchaserId,
        accountantId,
      } = res;
      this.paymentForm.supplierPaymentRemaining = supplierPaymentRemaining;
      this.paymentForm.supplierCashRemaining = supplierCashRemaining;
      this.paymentForm.purchaser = purchaser;
      this.paymentForm.purchaserId = purchaserId;
      this.paymentForm.accountant = accountantId;
      this.paymentForm.paymentAmount = paymentAmount;
      this.paymentForm.customers = customers.toString();
      this.paymentForm.sellers = sellers.toString();
      (this.$refs.otherFees as any).paymentVoucherOtherFeeResListGIVE(res.paymentVoucherOtherFeeResList);
      (this.$refs.createPayment as any).relationPaymentVoucherResListGIVE(res.relationPaymentVoucherResList);
      loading.close();
    }).catch(err => {
      console.log(err);
      loading.close();
    });
  }

  private handleSuccess() {
    this.showFee = false;
    this.getList();
  }

  private handleAddMark() {
    this.paymentForm.markList.push({
      value: "",
    });
  }

  // 删除唛头
  private handleDeleteMark(index) {
    this.paymentForm.markList.splice(index, 1);
  }

  public async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  public async handleFee() {
    this.showFee = true;
  }

  public async handleAmount() {
    this.showAmount = true;
  }

  private async getList() {
    const params = {
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getQuotationDetail(params);
    this.table.total = +total;
    this.table.list = list;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async submitForm(): Promise<void> {
    console.log(this.paymentForm);
    this.$confirm("确定要创建付款单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      (this.$refs.ruleForm as any).$refs.ruleForm.validate(
        async (valid: boolean) => {
          if (valid) {
            if (this.paymentForm.type !== "OTHER") {
              if (!this.paymentForm.relationType
                  || !this.paymentForm.relationPurchaseOrder
                  || this.paymentForm.relationPurchaseOrder.length === 0) {
                this.$message({
                  message: "付款单性质非'其他'的，需要选择关联单据",
                  type: "error",
                });
                return;
              }
            }
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            try {
              let paymentVoucherOtherFees = (this.$refs.otherFees as any).table
                .list;
              let relationList = (this.$refs.createPayment as any).table.list;
              const { relationPurchaseOrder, relationType } = this.paymentForm;
              // this.getList(this.form);
              let relationPaymentVouchers = relationList.map((item) => {
                return {
                  relationId: item.id,
                  userAmount: item.useAmount,
                };
              });
              let paymentVoucherPoOtherFees = [];
              if (this.codesType === "HQ_PACKING_LIST") {
                paymentVoucherPoOtherFees = (this.$refs.purchaseOrderFee as any).table.list;
              }
              this.paymentForm.purchaser = this.paymentForm.purchaserId;
              await createPayment({
                ...this.paymentForm,
                paymentVoucherOtherFees,
                relationPaymentVouchers,
                paymentVoucherPoOtherFees,
                relationPurchaseOrder:
                  relationType === "采购订单"
                    ? Array.isArray(relationPurchaseOrder)
                      ? relationPurchaseOrder.length === 0
                        ? null
                        : relationPurchaseOrder.toString()
                      : relationPurchaseOrder
                    : null,
                relationPackingList: Array.isArray(relationPurchaseOrder)
                  ? relationType === "装箱单"
                    ? relationPurchaseOrder
                    : []
                  : relationType === "装箱单"
                  ? [relationPurchaseOrder]
                  : [],
              }).then(async (vite:any) => {
                if(relationType === "装箱单") {
                  await this.saveClaimTable(vite).then(res => {
                    this.$notify({
                      title: "成功",
                      message: "操作成功",
                      type: "success",
                      duration: 2000,
                    });
                    loading.close();
                    setTimeout(() => {
                      this.$router.go(-1);
                    }, 1500);
                  }).catch(err => {
                    console.log(err);
                    loading.close();
                  });
                } else {
                  this.$notify({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                    duration: 2000,
                  });
                  loading.close();
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 1500);
                }
              }).catch(err => {
                console.log(err);
                loading.close();
              });
            } catch (error) {
              console.error(error);
            } finally {
              loading.close();
            }
          }
        }
      );
    })
    .catch((err) => {
      console.error(err);
    });
  }
  private async saveClaimTable(vite) {
    let claimTable = (this.$refs.createClaim as any).table.list;
    console.log("claimTableclaimTable", claimTable);
    let claimDeductionReqList = claimTable.map((item) => {
      return {
        claimFormId: item.id,
        deductionAmount: item.deductionAmount || 0,
        remark: item.remark || "",
      };
    });
    let data = {
      relationDocumentId: vite.id,
      relationDocumentCode: vite.code,
      relationDocumentType: this.paymentForm.relationType === '采购订单'?'PURCHASE_ORDER':'HQ_PACKING_LIST',
      claimDeductionReqList,
    };
    try {
      await putPurchaseOrder(data);
      this.$notify({
        title: "成功",
        message: "索赔单据保存成功",
        type: "success",
        duration: 2000,
      });
    } catch {
      this.$notify({
        title: "失败",
        message: "索赔单据保存失败",
        type: "error",
        duration: 2000,
      });
    }
  }
}
